<template>
	<div class="ng-scope show-sticky-calc" >
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="page-content-container">
			<div class="page-category-container">
				<div class="container page-category-content">
					<div class="row">
						<div class="page-content-section js-regions-container col-md-24 col-sm-24">
							<div class="content-category-region">
								<div class="comp-content-category-container">
									<div class="sms-wgt-catalog scroll-lazy comp-collection-item-container comp-4col-collection-item-container">
										<div class="collection-container">
											<div class="collection-heading with-view-all">
												<div class="content-wrapper">
													<h2>"{{searchName}}" {{$t('product.searchresult')}}</h2>
												</div>
											</div>
											<div class="catalog-items-container">
												<div class="custom-grid-column" v-for="(products,pndex) in productList" :key="pndex">
													<a href="javascript:void(0)" @click="openPage('/product?no='+products.product_no)" class="catalog-item-details-container catalog-item-link-wrapper collection-item ">
														<div class="wgt-catalog-image">
															<img :src="products.icon"/>
															<div class="wgt-catalog-button btn site-btn-primary">{{$t('common.learnmore')}}</div>
														</div>
														<div class="catalog-description-container custom-height">
															<div class="wgt-catalog-title">{{products.productname}}</div>
															
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="page-container">
											<el-pagination background layout="total, prev, pager, next, jumper" :total="totalNum"
												:current-page.sync="pagesize" :page-size="pagenum" @current-change="handleCurrentChange"
												@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
										</div>
									</div>
									<div class="sms-wgt-text-image scroll-lazy lazy-loaded">
										<div class="wgt-text-content">
											<hr />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import {searchProductByName} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal
		},
		data() {
			return {
				isMobile: false,
				showLoginModal: false,
				productList:[],
				pagesize:1,
				pagenum:20,
				totalNum:0,
				searchName:''
			};
		},
		mounted() {},
		beforeDestroy() {},
		created() {
			this.isMobile = this.webIsMobile()
			if(this.$route.query.search){
				this.searchName = this.$route.query.search;
				this.init()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {
					productName:this.searchName,
					pagesize:this.pagesize,
					pagenum:this.pagenum
				}
				searchProductByName(params).then(res => {
					if (res.code == 200) {
						that.productList = res.data.list
						that.totalNum = res.data.total
					}
				})
			},
			openLoginMadal() {
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal() {
				this.showLoginModal = false
			},
			changeRegister(e) {
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/category.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>